export const activitiesQueryKeys = {
  all: ["activities"] as const,
  get: (id: string, structureId?: string) =>
    [...activitiesQueryKeys.all, id, structureId] as const,
  event: (id: string, structureId?: string) =>
    [...activitiesQueryKeys.all, "event", id, structureId] as const,
};
